export default __webpack_public_path__ + "static/media/slide-3.45412f8a.png";